<template>
    <v-card class="hotel-info-descriptions" elevation="0">
        <v-card-text class="hotel-info-descriptions__items text--primary">
            <template v-for="(description, index) in descriptions" :key="index">
                <div v-if="checkDescription(description)" class="hotel-info-descriptions__item">
                    <h4 class="hotel-info-descriptions__item-title">{{ descriptionTypeLabel(description) }}</h4>
                    <div
                        v-for="(text, textIndex) in description.descriptions"
                        :key="textIndex"
                        class="hotel-info-descriptions__item-text my-2"
                        v-html="text"
                    />
                </div>
            </template>
        </v-card-text>
    </v-card>
</template>

<script lang="ts">
    import {Component, Prop, Vue} from 'vue-facing-decorator'
    import {unescape} from 'lodash-es'

    @Component
    export class HotelInfoDescriptions extends Vue {
        @Prop({default: null}) descriptionsProp

        descriptionTypeLabel(description) {
            if (this.$te(`description_type.${description?.type.toLowerCase()}`)) {
                return this.$t(`description_type.${description?.type.toLowerCase()}`)
            }

            return description?.type
        }

        checkDescription({descriptions}) {
            const pattern = /^<p>&nbsp;<\/p>(\n)?$/
            if (descriptions.length === 1 && pattern.test(descriptions[0])) {
                return false
            }
            return true
        }

        get descriptions() {
            const descriptions =
                    this.descriptionsProp ||
                    (hotelsRuntimeStore.hotelInfoResponse.hotelDescriptionInfo.descriptions
                        ? hotelsRuntimeStore.hotelInfoResponse.hotelDescriptionInfo.descriptions.description
                        : []),
                groupedDescriptions = []
            descriptions.forEach(description => {
                const groupedDescriptionIndex = groupedDescriptions.findIndex(
                    groupedDescription => groupedDescription.type === description.type
                )
                if (groupedDescriptionIndex === -1) {
                    groupedDescriptions.push({
                        type: description.type,
                        descriptions: [unescape(description.description)],
                    })
                } else {
                    groupedDescriptions[groupedDescriptionIndex].descriptions.push(unescape(description.description))
                }
            })
            groupedDescriptions.sort(item => (item.type === 'short' ? -1 : item.type === 'general' ? 0 : 1))

            if (
                groupedDescriptions[0] &&
                groupedDescriptions[0].type === 'short' &&
                groupedDescriptions[1] &&
                groupedDescriptions[1].type === 'general' &&
                groupedDescriptions[1].descriptions[0].indexOf(groupedDescriptions[0].descriptions[0]) !== -1
            ) {
                groupedDescriptions.splice(0, 1)
            }
            return groupedDescriptions
        }
    }

    export default HotelInfoDescriptions
</script>

<style scoped></style>
